import { render, staticRenderFns } from "./SignInButton.vue?vue&type=template&id=3a0a8fd5&scoped=true&"
import script from "./SignInButton.vue?vue&type=script&lang=js&"
export * from "./SignInButton.vue?vue&type=script&lang=js&"
import style0 from "./SignInButton.vue?vue&type=style&index=0&id=3a0a8fd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0a8fd5",
  null
  
)

export default component.exports